import { DecisionMakerIcon } from '@change/ds-icons';

import { Avatar, Badge } from '@change/ds-core-ui/next';

type AvatarAndBadgeProps = {
	photoUrl: string | null;
	displayName: string;
};

export const AvatarAndBadge: React.FC<AvatarAndBadgeProps> = ({ displayName, photoUrl }) => {
	return (
		<div className="relative flex justify-center">
			<Avatar src={photoUrl || undefined} alt={displayName} className="size-14 flex-shrink-0 lg:size-20" />
			<div
				data-testid="politician-badge"
				className="bg-fill-accent-primary-weaker absolute bottom-[-20px] z-10 flex size-6 items-center justify-center rounded-full border-4 border-white md:size-10"
			>
				<Badge iconOnly leadingIcon={<DecisionMakerIcon />} size="large" />
			</div>
		</div>
	);
};
